<template>
  <div class="wrapper">
    <div class="effective">
      <!-- 左半部分 -->
      <div class="left-effective">
        <div class="" style="margin-left: -140px;">
          <div class="" style="display: inline-block;" >
            发票号：
          </div>
           <div class="context">
            {{WarnInfoData.InvoiceNo}}
          </div>
        </div>
      </div>
      <!--右半部分-->
      <!-- <div class="right-effective">
        <div class="">
          <div class="title-effective">
            经营方式：
          </div>
          <div class="context">
            制造
          </div>
        </div>
        <div class="border-context" >
          <div class="title-effective">
            备案日期：
          </div>
          <div class="context">
            2022-10-14
          </div>
        </div>
      </div> -->
    </div>
    <div class="reject-invoice">
      <img src="@/assets/channel/reject.png" alt="" style="width: 24px;height:24px;vertical-align: middle;margin-right: 10px;">
      {{WarnInfoData.StringMessage}}
    </div>
  </div>
</template>

<script>
import CommonuploadEnclosure from '../../../../../../../components/common-upload-Enclosure.vue'
export default {
  components: { CommonuploadEnclosure },
  props: {
    WarnInfoData: {
      type: Object
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url(../../style/index.less);
</style>  